export const lazyLoadPurchaseComponent = () =>
  import(
    './components/purchase-frequency-activity/purchase-frequency-activity.component'
  ).then(m => m.PurchaseFrequencyActivityComponent);
